<template>
  <div class="ordinaryModify">
    <el-dialog
      :popper-append-to-body="false"
      center
      :title="'黄金镶嵌现货列表' + '(' + modifyingReplication.styleNumber + ')'"
      :close-on-click-modal="false"
      :visible.sync="goldsettingSpotDialogVisible"
      :before-close="handleClose"
    >
      <el-table
        :data="gridData"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        style="width: 100%"
        class="tableData"
        :row-class-name="tableRowClassName"
      >
        <el-table-column property="" label="参数信息" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.gender">{{ scope.row.gender }}戒</span>
          </template>
        </el-table-column>
        <el-table-column property="texture" label="材质" width="90"></el-table-column>
        <el-table-column property="mainStoneName" label="主石名称" width="85"></el-table-column>
        <el-table-column property="mainStoneNumber" label="主石数量" width="85"></el-table-column>
        <el-table-column property="mainStoneWeight" label="主石重量" width="85"></el-table-column>
        <el-table-column property="assistStoneNameOne" label="辅石1名称" width="85"></el-table-column>
        <el-table-column property="assistStoneNumberOne" label="辅石1数量" width="85"></el-table-column>
        <el-table-column property="assistStoneWeightOne" label="辅石1重量" width="85"></el-table-column>
        <el-table-column property="goldenWeigh" label="金重" width="65"></el-table-column>
        <el-table-column property="totalWeight" label="总重量" width="65"></el-table-column>
        <el-table-column property="mainStoneClarity" label="净度" width="65"></el-table-column>
        <el-table-column property="mainStoneColor" label="色度" width="65"></el-table-column>
        <el-table-column property="" label="GIA" width="65">
          <template slot-scope="scope">
            <span>{{ scope.row.gia | cutFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column property="spec" label="规格" width="65"></el-table-column>
        <el-table-column property="seriesName" label="系列" width="90"></el-table-column>
        <el-table-column
          property="tradePrice"
          v-if="hasPriceViewPermission()"
          label="结算金额"
          width="90"
        ></el-table-column>
        <el-table-column property="labelPrice" label="标签价格" width="90"></el-table-column>
        <el-table-column property="" label="状态" width="65">
          <template slot-scope="scope">
            <span>{{ scope.row.cartStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column property="" label="操作" width="70">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="deleteSpot(scope.row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageClass">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="listQuery.current"
          :page-size="listQuery.size"
          @current-change="cartSpotListCurrentPage($event)"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { spotPageList, modifyCartPublic } from '@/api/cartApi';
import { cutFilter } from '@/utils/filetrs';
export default {
  props: {
    goldsettingSpotDialogVisible: Boolean,
    modifyingReplication: {
      type: Object,
      default() {
        return {};
      },
    },
    addOrderList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      listQuery: {
        current: 1,
        size: 9,
        cartId: '',
        sequenceList: [],
      },
      total: 0,
      gridData: [],
    };
  },
  filters: {
    cutFilter,
  },
  mounted() {
    this.addOrderList.forEach((res) => {
      res.forEach((item) => {
        item.cartList.forEach((ele) => {
          // if (ele.id === this.modifyingReplication.id && ele.texture === this.modifyingReplication.texture && ele.gender === this.modifyingReplication.gender) {
          this.listQuery.sequenceList.push(ele.sequence);
          // }
        });
      });
    });
    this.getSpotList();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.cartStatus === '下架' || row.cartStatus === '已售') {
        return 'warning-row';
      }
      return '';
    },
    // 删除现货
    deleteSpot(row) {
      let obj = [
        {
          id: this.modifyingReplication.id,
          sequences: [row.sequence],
        },
      ];
      modifyCartPublic(obj, 'delete').then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success',
            duration: 1500,
          });
          this.getSpotList();
        }
      });
    },
    // 获取列表数据
    getSpotList() {
      this.listQuery.cartId = this.modifyingReplication.id;
      spotPageList(this.listQuery).then((res) => {
        this.gridData = [];
        res.data.records.forEach((item) => {
          this.gridData.push(item);
        });
        if (res.data.records?.length == 0) {
          this.$emit('onCloseSelectDialog');
          // 修改购物车数据
          this.$emit('updataCart');
        }
        this.total = res.data.total;
      });
    },
    // 分页
    cartSpotListCurrentPage(ev) {
      this.listQuery.current = ev;
      this.getSpotList();
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('onCloseSelectDialog');
      // 修改购物车数据
      this.$emit('updataCart');
    },
  },
};
</script>

<style scoped lang="scss">
.ordinaryModify {
  /deep/ .el-dialog {
    max-width: 1500px;
    width: 100%;
  }

  /deep/ .el-dialog--center .el-dialog__body {
    padding: 0 10px 10px 10px;
  }

  /deep/ .el-table .cell {
    padding: 0;
  }

  .el-button {
    width: 100%;
  }

  .el-button--text {
    color: red;
  }

  .pageClass {
    text-align: center;
    padding: 20px 0;
    background: #fff;
  }

  /deep/ .el-table .warning-row {
    background: #f3f3f3;
  }

  /deep/ .el-pager li.active + li {
    border-left: none;
  }
}
</style>
